import { ISelectOption } from "src/app/shared/interfaces/select-option.interface";
import { ITypeSetItem } from "src/app/shared/util/type-set";
interface ICustomReportingPlan {
    planId: number;
    memberId: number;
    description: string;
    minCycleData?: Date;
    maxCycleData?: Date;
    paymentTypeId: number;
}
export class CustomReportingPlan implements ICustomReportingPlan, ISelectOption<number>, ITypeSetItem<CustomReportingPlan> {
    public readonly planId: number;
    public readonly memberId: number;
    public readonly description: string;
    public readonly minCycleData?: Date;
    public readonly maxCycleData?: Date;
    public readonly paymentTypeId: number;

    // ISelectOption<number>
    public get value() { return this.planId; }
    public get label() { return this.description; }

    constructor(cycle: ICustomReportingPlan) {
        this.planId = cycle.planId;
        this.memberId = cycle.memberId;
        this.description = cycle.description;
        this.minCycleData = cycle.minCycleData; 
        this.maxCycleData = cycle.maxCycleData;
        this.paymentTypeId = cycle.paymentTypeId;
    }

    // ITypeSetItem<CustomReportingPlan>
    public equalTo (other: CustomReportingPlan) : boolean { 
        return this.planId === other.planId && this.memberId === other.memberId;
    }

    public static sort (a: ICustomReportingPlan, b: ICustomReportingPlan) {
        if (a.description === b.description) {
            // TODO: Check if maybe sortng by cycle makes more sense
            return a.planId - b.planId;
        }
        return a.description.localeCompare(b.description);
    }
}